
import { Question, QuestionType } from "@/types/test";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

interface QuestionTypeSelectorProps {
  value: QuestionType;
  onChange: (value: QuestionType) => void;
  className?: string;
}

export const QuestionTypeSelector = ({ value, onChange, className }: QuestionTypeSelectorProps) => {
  console.log('🎯 QuestionTypeSelector rendering with value:', value);
  
  const handleValueChange = (newValue: QuestionType) => {
    console.log('🔄 QuestionTypeSelector value changing to:', newValue);
    onChange(newValue);
  };

  return (
    <Select value={value} onValueChange={handleValueChange}>
      <SelectTrigger className={cn(className)}>
        <SelectValue placeholder="Question Type" />
      </SelectTrigger>
      <SelectContent className={className}>
        <SelectItem value="multiple_choice">Multiple Choice</SelectItem>
        <SelectItem value="essay">Essay</SelectItem>
        <SelectItem value="audio_response">Audio Recording</SelectItem>
        <SelectItem value="video_response">Video Recording</SelectItem>
        <SelectItem value="coding">Coding</SelectItem>
      </SelectContent>
    </Select>
  );
};
